import { render, staticRenderFns } from "./repairDetailList.vue?vue&type=template&id=4b8ff276&scoped=true"
import script from "./repairDetailList.vue?vue&type=script&lang=js"
export * from "./repairDetailList.vue?vue&type=script&lang=js"
import style0 from "./repairDetailList.vue?vue&type=style&index=0&id=4b8ff276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ff276",
  null
  
)

export default component.exports